import { defineAsyncComponent } from "vue";

const AccountSettings = () => import("./pages/AccountSettings.vue");

const AccountInformation = defineAsyncComponent({
    loader: () => import("./pages/AccountSettings/AccountInformation.vue"),
});
const SecuritySettings = defineAsyncComponent({
    loader: () => import("./pages/AccountSettings/SecuritySettings.vue"),
});

const InterfaceSettings = defineAsyncComponent({
    loader: () => import("./pages/ApplicationSettings/InterfaceSettings.vue"),
});
const CompanySwitch = defineAsyncComponent({
    loader: () => import("./pages/ApplicationSettings/CompanySwitch.vue"),
});

const CompanySettings = () => import("./pages/CompanySettings.vue");
// const IntegrationSettings = defineAsyncComponent({
//     loader: () =>
//         import(
//             "@dutypay/settings-pages/src/pages/CompanySettings/IntegrationSettings.vue"
//         ),
// loadingComponent: LoadingPage,
// });
const CompanyInformation = defineAsyncComponent({
    loader: () => import("./pages/CompanySettings/CompanyInformation.vue"),
});

import { pages } from "@front-end-application/pages.mjs";

export const routes = [
    // ----------------
    //  PAGES
    // ----------------

    ...pages,

    // ----------------
    //  SETTINGS
    // ----------------
    {
        path: "/account-settings",
        component: AccountSettings,
        children: [
            {
                path: "account-information",
                component: AccountInformation,
            },
            {
                path: "security-settings",
                component: SecuritySettings,
            },
        ],
    },

    {
        path: "/application-settings",
        component: AccountSettings,
        children: [
            {
                path: "company-switch",
                component: CompanySwitch,
            },
            {
                path: "interface-settings",
                component: InterfaceSettings,
            },
        ],
    },

    {
        path: "/company-settings",
        component: CompanySettings,
        children: [
            // {
            //     path: "integrations",
            //     component: IntegrationSettings,
            // },
            {
                path: "company-information",
                component: CompanyInformation,
            },
        ],
    },
];
